import {
  V2ListQuotesForAccountApiArg,
  V2LineOfBusinessResource,
  V2VendorResource,
  useV2ListQuotesForAccountQuery,
} from "@generated";
import { Quote } from "../../types/Quote";
import { getFormattedQuote } from "../../quoteHelpers/quoteHelpers";

export interface HookArgs {
  page?: V2ListQuotesForAccountApiArg["page"];
  include?: V2ListQuotesForAccountApiArg["include"];
  filter?: V2ListQuotesForAccountApiArg["filter"];
}

const useListQuotes = ({ page, include, filter }: HookArgs) => {
  const { data, error, isLoading, refetch } = useV2ListQuotesForAccountQuery({
    page,
    include,
    filter,
  });

  let quotes: Quote[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };
  let vendors = data?.included?.filter(
    (item) => item.type === "vendors"
  ) as V2VendorResource[];
  let lobs = data?.included?.filter(
    (item) => item.type === "lobs"
  ) as V2LineOfBusinessResource[];

  if (data?.data) {
    try {
      quotes = data.data.map((quote) => {
        if (!quote.id) {
          throw new Error("Missing quote.id");
        }

        return getFormattedQuote(quote, vendors, lobs);
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    quotes: quotes,
    quotesError: error || customError,
    quotesLoading: isLoading,
    pageMeta,
    refetch,
  };
};

export default useListQuotes;
